import { Icon } from '@pms-digital/design-system';

interface MessageIndisponibleProps {
  children: string;
}

/**
 * A sober message in place of what Tahiti did not give (A10): grey background, `info` icon,
 * one sentence. Not an alert: nothing went wrong that the user can act on.
 */
export function MessageIndisponible({ children }: MessageIndisponibleProps) {
  return (
    <p className="mt-3 flex items-center gap-3 rounded-md bg-gray-50 px-6 py-4 text-body text-gray-700 leading-normal">
      <Icon name="info" size={24} />
      {children}
    </p>
  );
}
